var _circle, _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _g5, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconeConsumoAlimentar = function SvgIconeConsumoAlimentar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 16,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_d_14652_32176)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 16,
    fill: "#9BE1D8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_14652_32176)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7339 10.6C16.6228 10.6 17.0672 11.0444 17.0672 11.9333V12.6C18.845 12.6 19.7339 13.4885 19.7339 15.2657V15.9331C19.7339 17.711 18.845 18.6 17.0672 18.6C17.0672 19.4889 16.623 19.9333 15.7346 19.9333H9.73385C8.84518 19.9333 8.40074 19.4889 8.40051 18.6V11.9333C8.40051 11.0444 8.84498 10.6 9.73392 10.6H15.7339ZM17.0672 13.9333V17.2666C17.9157 17.2666 18.3593 16.8617 18.3978 16.0518L18.4006 15.9333V15.2685C18.4006 14.3784 17.9561 13.9333 17.0672 13.9333Z",
    fill: "#005E55"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_14652_32176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4008 5.952C12.4006 5.39733 12.1351 5.12 11.6044 5.12C11.0737 5.12 10.8058 5.39733 10.8008 5.952V8.44799C10.801 9.00266 11.0677 9.27999 11.6008 9.27999C12.1339 9.27999 12.4006 9.00266 12.4008 8.44799V5.952Z",
    fill: "#DBF6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8008 7.616C14.8006 7.06133 14.5339 6.784 14.0008 6.784C13.4677 6.784 13.201 7.06133 13.2008 7.616V8.44799C13.2055 9.00266 13.4734 9.27999 14.0042 9.27999C14.535 9.27999 14.8006 9.00266 14.8008 8.44799V7.616Z",
    fill: "#DBF6F2"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_14652_32176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.778 17.3653C14.2451 17.1958 11.3144 18.0967 9.06825 19.9802C6.82208 21.8636 7.73598 23.8677 10.1676 24.4407C12.5993 25.0137 16.9999 24.9675 19.9435 23.9723C22.8871 22.9772 23.1826 21.6854 23.0813 20.6427C22.98 19.6 21.63 17.5501 17.778 17.3653Z",
    fill: "#DBF6F2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.83828 19.706C11.1653 17.7547 14.1891 16.8349 17.7951 17.0079C21.768 17.1984 23.314 19.3374 23.4375 20.6081C23.4933 21.1824 23.4415 21.8657 22.9415 22.5388C22.4512 23.1988 21.564 23.8022 20.0581 24.3114C18.5427 24.8237 16.6697 25.0871 14.8766 25.1522C13.0839 25.2173 11.3419 25.0851 10.0855 24.7891C8.80516 24.4874 7.82637 23.7855 7.52205 22.8083C7.21046 21.8078 7.65626 20.6971 8.83828 19.706ZM9.06823 19.9802C11.3144 18.0967 14.245 17.1959 17.778 17.3653C21.63 17.5501 22.98 19.6 23.0813 20.6427C23.1826 21.6854 22.8871 22.9772 19.9435 23.9723C16.9999 24.9675 12.5993 25.0137 10.1676 24.4407C7.73597 23.8677 6.82207 21.8637 9.06823 19.9802Z",
    fill: "#36A094"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.97565 23.9798C11.7588 24.3078 15.6113 24.1157 18.3415 23.1927C21.6289 22.0813 21.9589 20.6387 21.8458 19.4742C21.8168 19.1753 21.6958 18.8023 21.4593 18.4094C22.5611 19.1263 23.0247 20.0482 23.0825 20.6426C23.1838 21.6853 22.8883 22.9771 19.9447 23.9723C17.0011 24.9674 12.6005 25.0137 10.1688 24.4407C9.71456 24.3336 9.31327 24.1766 8.97565 23.9798Z",
    fill: "#9BE1D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4924 21.9919C13.2633 20.5289 11.588 19.2563 10.779 18.8029C11.2696 18.3825 12.0617 18.1595 12.3965 18.1005C13.5049 19.4215 13.5889 21.2452 13.4924 21.9919Z",
    fill: "#1E8B7F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7328 21.7988C16.5411 19.8579 15.2523 17.9758 14.4433 17.5224C15.1474 17.2399 16.3059 17.3453 16.6407 17.2863C17.954 18.6685 16.8293 21.0521 16.7328 21.7988Z",
    fill: "#1E8B7F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1749 20.7594C20.0473 18.7967 19.3206 18.1563 18.73 17.4413C19.1788 17.4032 20.1827 17.7739 20.5162 17.8398C20.8826 18.984 20.6391 19.7299 20.1749 20.7594Z",
    fill: "#1E8B7F"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_14652_32176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7183 20.368C28.7183 22.5884 27.3678 24.9138 25.4434 25.7269C24.8028 25.9975 24.0986 25.4292 23.3594 25.4292C22.7407 25.4292 21.8283 25.9198 21.2754 25.7269C19.1833 24.997 18.0005 22.7089 18.0005 20.368C18.0005 17.4083 20.3997 16.2 23.3594 16.2C26.319 16.2 28.7183 17.4083 28.7183 20.368Z",
    fill: "#50BBAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2293 19.4749C27.3937 19.4749 27.527 19.6081 27.527 19.7726C27.527 20.1994 27.4481 20.8861 27.2142 21.5928C26.9809 22.2982 26.5836 23.0521 25.9267 23.5776C25.7983 23.6804 25.611 23.6595 25.5082 23.5311C25.4055 23.4028 25.4263 23.2154 25.5547 23.1127C26.0887 22.6855 26.4357 22.0501 26.6489 21.4058C26.8617 20.7629 26.9316 20.1397 26.9316 19.7726C26.9316 19.6081 27.0649 19.4749 27.2293 19.4749Z",
    fill: "#DBF6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4775 17.4191C25.2882 17.4472 24.029 17.6443 23.0959 17.6207C22.3698 17.6023 21.4829 17.5079 21.2474 17.4154C21.0119 17.323 20.8487 17.5056 21.1059 17.7279C21.5056 18.0731 22.2016 18.5138 23.15 18.5138C24.0985 18.5138 24.9748 18.0731 25.5157 17.7279C25.7095 17.6041 25.6668 17.3909 25.4775 17.4191Z",
    fill: "#1E8B7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6004 17.8C23.3337 16.2 23.601 15.4 24.4001 14.6",
    stroke: "#00443D",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0455 14.9302C24.7396 15.1028 24.2923 15.2673 23.6015 15.4C23.6015 15.4 23.3332 16.1999 25.2006 16.1999C25.875 16.1999 26.3257 16.037 26.6163 15.7946C27.6841 14.9036 26.2567 14.2467 25.0455 14.9302Z",
    fill: "#00443D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14652_32176",
    x: 0.222222,
    y: 0.111111,
    width: 35.5556,
    height: 35.5556,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.888889
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.888889
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.313726 0 0 0 0 0.733333 0 0 0 0 0.686275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_32176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_32176",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_14652_32176",
    x: 7.40051,
    y: 9.59998,
    width: 13.3334,
    height: 11.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.368627 0 0 0 0 0.333333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_32176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_32176",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_14652_32176",
    x: 10.2408,
    y: 4.56,
    width: 5.12,
    height: 5.28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00784314 0 0 0 0 0.470588 0 0 0 0 0.427451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_32176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_32176",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_14652_32176",
    x: 7.22442,
    y: 16.7852,
    width: 16.4331,
    height: 8.58545,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00784314 0 0 0 0 0.470588 0 0 0 0 0.427451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_32176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_32176",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_14652_32176",
    x: 17.0005,
    y: 13.2,
    width: 12.7178,
    height: 13.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.368627 0 0 0 0 0.333333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_32176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_32176",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconeConsumoAlimentar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icone-consumo-alimentar.ccb3627f.svg";
export { ForwardRef as ReactComponent };